function text(value) {
  return String(value ?? "");
}

export function appendCell(row, value, options = {}) {
  const cell = document.createElement(options.header ? "th" : "td");

  if (options.className) cell.className = options.className;
  if (options.colSpan) cell.colSpan = options.colSpan;
  if (options.title) cell.title = text(options.title);
  if (options.align) cell.style.textAlign = options.align;

  cell.textContent = text(value);
  row.appendChild(cell);
  return cell;
}

export function appendButton(container, options = {}) {
  const button = document.createElement("button");
  button.type = "button";
  button.textContent = text(options.label);

  if (options.className) button.className = options.className;
  if (options.title) button.title = text(options.title);
  if (options.disabled) button.disabled = true;

  if (options.dataset) {
    for (const [key, value] of Object.entries(options.dataset)) {
      if (value === undefined || value === null) continue;
      button.dataset[key] = text(value);
    }
  }

  container.appendChild(button);
  return button;
}

export function appendStatusPill(container, label, styleText = "") {
  const pill = document.createElement("span");
  pill.className = "pill";
  if (styleText) pill.style.cssText = styleText;
  pill.textContent = text(label);
  container.appendChild(pill);
  return pill;
}
